{{#each links}}
  <a {{#if animation}}data-anijs="{{animation}}"{{/if}} class="{{#if class}}{{class}}{{else}}btn btn-default{{/if}}" href="{{path}}" id="{{id}}" title="{{{pt title}}}" {{attributes}}>
    {{#if sr_text}}
      <span aria-hidden="true">{{t text}}</span>
      <span class="screen-reader-content">{{t sr_text}}</span>
    {{else}}
      <span>{{t text}}</span>
    {{/if}}
  </a>
  {{#if title}}{{f 'editlocaleplain' title ../cid ../forge_path 'tool tip'}}{{/if}}
{{/each}}
